module.exports = __webpack_public_path__ + "static/img/ic_close2.6b23f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_close2.png
// module id = ng0M
// module chunks = 1